export default __webpack_public_path__ + "static/246-5af25b1c5e9c1c9d6680d2dce744efaa.gif";